import React, { Component } from "react";
import { Link } from "react-router-dom";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class OfflineSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "productType",
        label: "Product TYpe",
        type: "select",
      },
      {
        name: "mobileNumber",
        label: "Mobile No.",
        type: "number",
      },
      {
        name: "leadName",
        label: "Name",
        type: "text",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ADMIN_LEADS_STATUS,
      },
    ];

    this.isPanVerified = this.props.$store?.user?.is_pan_code_verified;
    this.isAadharVerified = this.props.$store?.user?.is_aadhar_verified;
    this.is_agreement_signed = this.props.$store?.user?.is_agreement_signed;
  }

  componentDidMount() {
    this.getProductTypes();

    const adminPersona =
      this.props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;

    if (!adminPersona) {
      console.log(
        this.isPanVerified,
        this.isAadharVerified,
        this.is_agreement_signed
      );

      if (
        !this.isPanVerified ||
        !this.isAadharVerified ||
        !this.is_agreement_signed
      ) {
        swal2
          .fire({
            title: "Account Verification Pending",
            text: "Please complete your profile to add lead",
            icon: "info",
            iconColor: "#234C9B",
            timer: 6000,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.props.navigate("/app/myprofile");
            }
          });
      }
    }
  }

  getProductTypes() {
    this.props.apis.apiGetProductTypes().then((res) => {
      let productType = this.fields.find((o) => o.name == "productType");
      productType.options = res;
    });
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    const isAdmin =
      this.props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
    return (
      <>
        <div className="d-flex align-items-center justify-content-end">
          <button
            type="button"
            className="btn filter_modal_btn"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
            <i class="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
          {!isAdmin &&
            this.isPanVerified &&
            this.isAadharVerified &&
            this.is_agreement_signed && (
              <Link
                className="btn btn-primary"
                onClick={(...args) => this.props.addModalFields(...args)}
              >
                Add Application
              </Link>
            )}
          <AppDynamicFilterModal
            open={openDrawer}
            onClose={this.closeDrawer}
            fields={this.fields}
            onSearch={this.onSearch}
            onReset={this.onReset}
          />
        </div>
      </>
    );
  }
}

export default constore(OfflineSearch);
